import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { VideoPlayerModule } from 'src/app/shared/video-player/video-player.module'
import { LinkModule } from '../link/link.module'
import { FloSanitizeHtmlPipeModule } from '../_pipes/sanitize-html/sanitize-html.pipe.module'
import { VideoPlayerCardComponent } from './video-player-card.component'

@NgModule({
  imports: [CommonModule, VideoPlayerModule, FloSanitizeHtmlPipeModule, LinkModule],
  declarations: [VideoPlayerCardComponent],
  exports: [VideoPlayerCardComponent]
})
export class VideoPlayerCardModule {}
